import script from "./IrrigationView.vue?vue&type=script&setup=true&lang=js"
export * from "./IrrigationView.vue?vue&type=script&setup=true&lang=js"

import "./IrrigationView.vue?vue&type=style&index=0&id=0d5dd1ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d5dd1ba"]])

export default __exports__